<template>
  <div class="whatWrap" id="page2">
    <h2>涿溪防窜货是什么？</h2>
    <p>专注于为日化企业提供国家标识服务、专利防伪服务、一物一码服务、裂变复购服务、<br />大数据管理服务，重新定义防伪营销，助力企业“码”上开源节流，裂变营销。</p>
    <div class="videocontain">
      <!-- <vue-core-video-player
        ref="VideoPlayer"
        :src="videoOrigin"
        :cover="coverOrigin"
        :autoplay="autoplay"
        :title="title"
        :loop = "loop"
        :preload = "preload"
      ></vue-core-video-player> -->
      <!-- <video src="" controls="controls" class="myVideo" /> -->
      <video src="https://mzmpic.oss-cn-beijing.aliyuncs.com/rihumaVideo.mp4" controls="controls" class="myVideo" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'codewhat',
  data () {
    // const MyVideo = require('../assets/images/home_video.mp4')
    return {
      videoOrigin: 'https://mzmpic.oss-cn-beijing.aliyuncs.com/rihumaVideo.mp4',
      coverOrigin: '',
      autoplay: true,
      language: 'zh-CN',
      title: '',
      loop: true, // 是否循环
      preload: 'metadata', // 'none'表示不会预加载 'metadata'表示只加载视频metadata部分信息
    }
  },
  methods:{

  }
}
</script>
<style scoped lang="scss">
.whatWrap{
  > h2 {
    font-size: 40px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: normal;
    color: #1F2329;
    line-height: 56px;
    margin-bottom: 18px;
    text-align: center;
  }
  > p {
    font-size: 18px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #707885;
    line-height: 28px;
    text-align: center;
    margin: 0 0 10px 0;
    padding: 0;
  }
  .videocontain{
    width: 65%;
    // height: 562px;
    margin: 0 auto;
  }
  .myVideo{
    width: 100%;
    // height: 562px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CodeWhat.vue